import { Routes } from '@angular/router';
import { UserRole } from '@shared/types/user';
import { checkPermissionGuard } from '../guards/check-permission.guard';
import { loggedInAuthGuard } from '../guards/is-logged-in.guard';

export const WHEEL_ROUTES: Routes = [
  {
    path: 'wheel-theme',
    loadChildren: () =>
      import('./theme/theme.module').then((m) => m.WheelThemeModule),
    canActivate: [loggedInAuthGuard, checkPermissionGuard],
    data: {
      permission: [UserRole.Admin, UserRole.ClientAdmin],
    },
  },
  {
    path: 'segments',
    loadChildren: () =>
      import('./segments/segments.module').then((m) => m.SegmentsModule),
    canActivate: [loggedInAuthGuard, checkPermissionGuard],
    data: {
      permission: [
        UserRole.Admin,
        UserRole.ClientAdmin,
        UserRole.Manager,
        UserRole.Supervisor,
      ],
    },
  },
  {
    path: 'wheel-games',
    loadChildren: () => import('./game/game.module').then((m) => m.GameModule),
    canActivate: [loggedInAuthGuard, checkPermissionGuard],
    data: {
      permission: [
        UserRole.Admin,
        UserRole.ClientAdmin,
        UserRole.Manager,
        UserRole.Supervisor,
        UserRole.CustomerSupport,
      ],
    },
  },
  // {
  //   path: 'wheel-submissions',
  //   loadChildren: () =>
  //     import('./submissions/submissions.module').then(
  //       (m) => m.SubmissionsModule,
  //     ),
  //   canActivate: [loggedInAuthGuard, checkPermissionGuard],
  //   data: {
  //     permission: [
  //       UserRole.Admin,
  //       UserRole.ClientAdmin,
  //       UserRole.Manager,
  //       UserRole.Supervisor,
  //       UserRole.CustomerSupport,
  //     ],
  //   },
  // },
];
